module.exports = __webpack_public_path__ + "img/white-logo.e6a077d5.svg";